import axios from "@/plugins/axios";

let url = "/api/v1/me/exchanges/gifts";

export const gifts = {
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    cash: {
        postExec(data) {
            return axios.post(`${url}/${data._id}/cash/exec`, data).then((result) => result.data);
        },
    },
};

export default gifts;
